import React, { useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';

import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

const FareItemTags = (props) => {
  const { tagItem, tags = [], plusItem } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  if (tags.length === 0) {
    return null;
  }
  return (
    <Box display="flex" flexDirection="row" className={className} style={style}>
      {tags.map((item, index) => {
        return (
          <>
            <Text key={index} {...tagItem}>
              {translate(`cmp-fare-item-category-${item}`, `cmp-fare-item-category-${item}`)}
            </Text>
            {tags.length - 1 !== index && <Text {...plusItem}>+</Text>}
          </>
        );
      })}
    </Box>
  );
};

FareItemTags.componentName = 'FareItemTags';

export default FareItemTags;
